import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  // 定义状态
  state: {
    label:[],
    value:[],
    data:[],
    props:[],
    labels:[],
    width:[],
  },
  mutations:{
    New_label(state,msg){
      state.label.push(msg);
    },
    New_value(state,msg){
      if(state.value.indexOf(msg)<=-1){
        state.value.push(msg);
      }
      else if(state.value.indexOf(msg)>-1){// 包含
        let index = state.value.indexOf(msg);
        state.value.splice(index,1);
      }
    },
    New_Data(state,msg){
      state.data = msg;
    },
    New_Props(state,msg){
      state.props.push(msg);
    },
    New_Labels(state,msg){
      state.labels.push(msg);
    },
    New_Width(state,msg){
      state.width.push(msg);
    },
  },
  getters:{

  }
});

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js